import { Link } from "react-router-dom";
import { useState } from "react";

export default function Layout({ children }) {
  const [menuOpen, setMenuOpen] = useState(false);

  // helper to close menu after click
  const handleLinkClick = () => setMenuOpen(false);

  return (
    <div
      className="flex flex-col min-h-screen bg-cover bg-center"
      style={{ backgroundImage: "url('/backgrounds/balloon.png')" }}
    >
      {/* Header */}
      <header className="bg-gradient-to-r from-pink-500 to-yellow-500 text-white p-4 flex items-center shadow-md relative">
        {/* Logo + Title */}
        <div className="flex items-center space-x-2 flex-shrink-0">
          <img src="/images/logo.png" alt="Popalooza Logo" className="h-10 w-auto" />
          <h1 className="font-bold text-xl">Popalooza</h1>
        </div>

        {/* Nav (desktop) */}
        <nav className="hidden md:flex space-x-6 ml-auto">
          <Link to="/">Home</Link>
          <Link to="/features">Features</Link>
          <Link to="/screenshots">Screenshots</Link>
          <Link to="/about">About</Link>
          <Link to="/faq">FAQ</Link>
          <Link to="/blog">Blog</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/privacy">Privacy</Link>
        </nav>

        {/* Hamburger (mobile only) */}
        <button
          className="md:hidden ml-auto focus:outline-none"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        {/* Mobile dropdown */}
        {menuOpen && (
          <nav className="absolute top-full left-0 w-full bg-pink-500 text-white flex flex-col space-y-2 p-4 md:hidden z-50">
            <Link to="/" onClick={handleLinkClick}>Home</Link>
            <Link to="/features" onClick={handleLinkClick}>Features</Link>
            <Link to="/screenshots" onClick={handleLinkClick}>Screenshots</Link>
            <Link to="/about" onClick={handleLinkClick}>About</Link>
            <Link to="/faq" onClick={handleLinkClick}>FAQ</Link>
            <Link to="/blog" onClick={handleLinkClick}>Blog</Link>
            <Link to="/contact" onClick={handleLinkClick}>Contact</Link>
            <Link to="/privacy" onClick={handleLinkClick}>Privacy</Link>
          </nav>
        )}
      </header>

      {/* Main */}
      <main className="flex-grow p-6 bg-white/80 rounded-lg shadow-md m-6">
        {children}
      </main>

      {/* Footer */}
      <footer className="bg-gray-200/90 text-center p-6">
        <p className="mb-4 text-gray-700">Ready to play? Get Popalooza now!</p>
        <a
          href="https://play.google.com/store/apps/details?id=com.thinksoftweb.Popalooza"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-blue-600 text-white px-8 py-3 rounded-lg shadow hover:bg-blue-700 transition"
        >
          Download Now on Google Play
        </a>
        <p className="mt-6 text-sm text-gray-600">© 2025 Popalooza. All rights reserved.</p>
      </footer>
    </div>
  );
}
